<script setup>
import { computed } from 'vue';
import TextInput from './TextInput.vue';
import Select from './Select.vue';

const props = defineProps({
	type: {
		type: String,
		default: 'text'
	},
	required: {
		type: Boolean,
		default: false
	},
	placeholder: {
		type: String,
		default: ''
	},
	choices: {
		type: Array,
		default: []
	},
	invalid: {
		type: Boolean,
		default: false
	}
});

const model = defineModel({
    type: [String, Number],
    required: true,
});

const component = computed(() => {
	switch (props.type) {
		case 'select':
			return Select;
		default:
			return TextInput;
	}
});
</script>

<template>
    <Component 
        :is="component"
        v-model="model"
        :placeholder="placeholder"
        :required="required == true"
        :invalid="invalid"
    >
        <template v-if="type == 'select'">
        	<option v-if="placeholder" value="" v-html="placeholder"></option>
        	<option v-for="choice in choices" v-html="choice"></option>
        </template>
    </Component>
</template>
